import type { ComponentPropsWithoutRef } from "react";

export const ConversationHeaderBar = (
  props: ComponentPropsWithoutRef<"div">,
) => (
  <div
    className="flex h-16 shrink-0 items-center justify-between gap-2.5 px-5 py-3"
    {...props}
  />
);
